import { WSLoader } from "@wingspanhq/fe-component-library";
import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { queriesExternalBankAccounts } from "@query";

type Props = {
  accountId: string;
  children: (
    externalBankAccount: ExternalBankAccount
  ) => React.ReactElement | null;
};

export const ContainerAccount: React.FC<Props> = ({ accountId, children }) => {
  const queryExternalBankAccount =
    queriesExternalBankAccounts.getExternalBankAccount.useQuery({
      bankAccountId: accountId
    });

  if (!queryExternalBankAccount.data) {
    return <WSLoader.Spinner size="XS" />;
  }

  return children(queryExternalBankAccount.data);
};
